function getTitle (vm) {
  const { title, } = vm.$options;
  if (title) {
    return typeof title === 'function'
      ? title.call(vm)
      : title;
  }
}

const serverTitleMixin = {
  created () {
    const title = getTitle(this);
    if (title) {
      this.$ssrContext.title = title.title ? title.title : '';
      this.$ssrContext.keywords = title.keywords ? title.keywords : '';
      this.$ssrContext.description = title.description ? title.description : '';
    }
  },
};

const clientTitleMixin = {
  created () {
    const title = getTitle(this);
    if (title) {
      document.title = title.title ? title.title : '';
      document.querySelector('meta[name="keywords"]').setAttribute('content', title.keywords ? title.keywords : '');
      document.querySelector('meta[name="description"]').setAttribute('content', title.description ? title.description : '');
    }
  },
};

export default process.env.VUE_ENV === 'server'
  ? serverTitleMixin
  : clientTitleMixin;



// WEBPACK FOOTER //
// src/util/title.js